<div class="modal-header">
    <b>Pratica {{record.code}} - {{record.addressItem.name}}</b>
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close();" >
          <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body">    
    <ul class="nav nav-tabs mb-2" id="myTab" role="tablist">
        <ng-container *ngFor="let p of record.phases;let i=index;">
            <li class="nav-item">
                <a class="nav-link" [class.active]="i==0" id="profile-tab" data-toggle="tab" href="#tabDossier{{i}}" role="tab" aria-controls="profile" aria-selected="false">
                    {{p.title}}
                </a>
            </li>
        </ng-container>
    </ul>
    <div class="tab-content" id="myTabContent">
        <ng-container *ngFor="let p of record.phases;let i=index;">

            <div class="tab-pane fade" [class.show]="i==0" [class.active]="i==0" id="tabDossier{{i}}" role="tabpanel" aria-labelledby="tabDossier{{i}}-tab">
                <div class="row">
                    <div class="col-lg-12">
                        <ng-container *ngFor="let s of p.sections">
                            <h5 class="text-primary mt-3" *ngIf="s.type=='section'">{{s.name}}</h5>
                            <ul class="list-group">
                                <ng-container *ngFor="let f of s.fields">

                                    <li class="list-group-item border-bottom" *ngIf="checkEnableCondition(s.fields,f.enable_condition_fieldname)" >
                                        <!-- <span class="text-gray mr-2" title="Tipo di campo">[{{f.type}}]</span> -->
                                        <span class="mr-2">{{f.name}}:</span>
                                            <ng-container [ngSwitch]="f.type">                                                
                                                <ng-container *ngSwitchCase="'boolean'">
                                                    <b *ngIf="f['value']==1">Sì</b>
                                                    <b *ngIf="f['value'] && f['value']==0">No</b>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'date'">
                                                    <b *ngIf="f['value']">{{f['value'] | date:"dd/MM/yyyy"}}</b>
                                                    <i *ngIf="f['value']" class="ml-2">({{f['value'] | date:"EEEE"}})</i>
                                                </ng-container>                                                
                                                <ng-container *ngSwitchCase="'formula'">
                                                    <b *ngIf="f['value']">{{calculateFormula(f['value'],s.fields)}}</b>
                                                </ng-container>                                            
                                                <ng-container *ngSwitchCase="'file'">
                                                    <span *ngIf="f['value']" class="text-info">[file]</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'table'">
                                                    <span *ngIf="f['value']" class="text-info">[tabella]</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'address'">
                                                    <span *ngIf="f['value']" class="text-info">[Anagrafica]</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'currency'">
                                                    <b *ngIf="f['value']">{{f['value']}} Euro</b>
                                                </ng-container>                                                
                                                <ng-container *ngSwitchDefault>
                                                    <b *ngIf="f['value']">{{f['value']}}</b>
                                                </ng-container>
                                            </ng-container>
                                        <span *ngIf="!f['value']"><i class="fa fa-exclamation-triangle text-pink" title="Valore assente"></i></span>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>                        
                    </div>
                </div>
            </div>            
        </ng-container>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary btn-sm" (click)="close();">Chiudi</button>
</div>